import React from 'react';
import { Card, Button, Space, Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface ImagePreviewProps {
  imageUrl: string | null;
  imageInfo?: {
    name: string;
    size: number;
    width?: number;
    height?: number;
  };
  onClear: () => void;
}

const ImagePreview: React.FC<ImagePreviewProps> = ({ 
  imageUrl, 
  imageInfo, 
  onClear 
}) => {
  if (!imageUrl) {
    return null;
  }

  // 格式化文件大小
  const formatFileSize = (bytes: number): string => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
  };

  return (
    <Card 
      title="原始图片" 
      extra={
        <Button 
          type="text" 
          danger 
          icon={<DeleteOutlined />} 
          onClick={onClear}
        >
          清除
        </Button>
      }
      style={{ marginBottom: '20px' }}
    >
      <div style={{ textAlign: 'center' }}>
        <img 
          src={imageUrl} 
          alt="预览图" 
          style={{ 
            maxWidth: '100%', 
            maxHeight: '300px',
            objectFit: 'contain'
          }} 
        />
      </div>
      
      {imageInfo && (
        <div style={{ marginTop: '16px' }}>
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            <Text>文件名: {imageInfo.name}</Text>
            <Text>文件大小: {formatFileSize(imageInfo.size)}</Text>
            {imageInfo.width && imageInfo.height && (
              <Text>尺寸: {imageInfo.width} x {imageInfo.height} 像素</Text>
            )}
          </Space>
        </div>
      )}
    </Card>
  );
};

export default ImagePreview;